import React from 'react'
import { PastDueTasksDataTable } from './PastDueTasks/PastDueTasksDataTable'

const PastDueTasks = () => {
  return (
    <div className="space-y-4">
      <PastDueTasksDataTable />
    </div>
  )
}
export default PastDueTasks
